import './styles/templates/innovation-awards.template.scss';

import GoBackComponent from './modules/go-back/go-back';
import RelatedResources from './modules/related-resources/related-resources';
import ShareComponent from './modules/share/share';
import FollowComponent from './modules/follow/follow';

(function () {
  FollowComponent.init();
  GoBackComponent.init();
  ShareComponent.init();
  RelatedResources.init();
})();
